import type { RootState } from '@/app/store';

// Basic selectors
export const selectMaterialMatchSummaryData = (state: RootState) =>
  state.materialMatchSummary.materialMatchSummaryData;
export const selectMaterialMatchSummaryLoading = (state: RootState) =>
  state.materialMatchSummary.loading;
export const selectMaterialMatchSummaryError = (state: RootState) =>
  state.materialMatchSummary.error;
